import React from "react";
import { Header, Main, Footer } from "./components";

import "./scss/general.scss";

export default function App() {
  return (
    <>
      <Header/>
      <Main/>
      <Footer/>
    </>
  );
}
